import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import { optimizeSupabaseImage, getOriginalUrl, IMAGE_SIZES } from "@/utils/imageOptimization";

interface CategoryCardProps {
  id: string;
  name: string;
  slug: string;
  image_url?: string;
}

export function CategoryCard({ name, slug, image_url }: CategoryCardProps) {
  return (
    <Link to={`/category/${slug}`} className="group block">
      <div className="relative aspect-[4/3] overflow-hidden rounded-lg bg-muted">
        {image_url ? (
          <>
            <img
            src={optimizeSupabaseImage(image_url, IMAGE_SIZES.categoryCard)}
            alt={`Browse ${name} products`}
            width="400"
            height="300"
            className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
            loading="lazy"
            onError={(e) => {
                const originalUrl = getOriginalUrl(image_url);
                if (e.currentTarget.src !== originalUrl) {
                  e.currentTarget.src = originalUrl;
                } else {
                  (e.currentTarget.nextElementSibling as HTMLElement | null)?.classList.remove('hidden');
                  e.currentTarget.style.display = 'none';
                }
              }}
            />
            <div className="hidden flex h-full w-full items-center justify-center bg-gradient-to-br from-primary/20 to-primary/5">
              <div className="text-6xl opacity-20">🎨</div>
            </div>
          </>
        ) : (
          <div className="flex h-full w-full items-center justify-center bg-gradient-to-br from-primary/20 to-primary/5">
            <div className="text-6xl opacity-20">🎨</div>
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
        <div className="absolute bottom-4 left-4 right-4">
          <h3 className="text-lg font-semibold text-white drop-shadow-md">
            {name}
          </h3>
        </div>
      </div>
    </Link>
  );
}